import cx from 'classnames'
import dynamic from 'next/dynamic'
import { SanityCaseOverviewCase } from '@data/sanity/queries/types/modules'
import { getPageUrl, PageType } from '@lib/routes'
import Icon from './icon'
import Photo from './photo'
import BaseInternalLink from './link/base-internal-link'

const MuxVideo = dynamic(() => import('@components/video/mux-video'))

type CaseCardProps = Pick<
  SanityCaseOverviewCase,
  'title' | 'slug' | 'coverMediaType' | 'coverImage' | 'coverVideo'
>

const CaseCard = ({
  title,
  slug,
  coverMediaType,
  coverImage,
  coverVideo,
}: CaseCardProps) => {
  const caseUrl = getPageUrl(PageType.CASE, slug)

  return (
    <BaseInternalLink
      href={caseUrl}
      className={cx(
        'flex flex-col justify-end rounded-4xl bg-gray',
        'transition-opacity duration-200 hover:opacity-70',
      )}
    >
      {coverMediaType === 'photo' && !!coverImage && (
        <Photo image={coverImage} imageClassName="rounded-4xl" />
      )}

      {coverMediaType === 'mux-video' && !!coverVideo && (
        <MuxVideo
          video={coverVideo}
          showControls={false}
          autoplay={false}
          autoplayOnHover={true}
          openModalOnClick={false}
          muted={true}
          loop={true}
          className="rounded-4xl"
        />
      )}

      <div className="flex justify-between items-center gap-1 py-4 px-6">
        <span className="text-lg font-bold">{title}</span>

        <div className="shrink-0 inline-flex justify-center items-center w-10 h-10 rounded-full leading-none text-xl bg-green-electric">
          <Icon name="ArrowRight" />
        </div>
      </div>
    </BaseInternalLink>
  )
}

export default CaseCard
